// import axiosInstance from './axiosInstance';
import { CitiesResponse, MenuResponse } from "../types/category-menu";
import axiosInstance from "./axiosInstance";

class CategoryService {
  static async getMenu(): Promise<MenuResponse | undefined> {
    try {
      const response =
        await axiosInstance.get<ApiResponse<MenuResponse>>(`/categories/all`);
      return response.data.result;
    } catch (error) {}
  }

  static async getCategories(
    productType: string | null,
  ): Promise<LocationDTO[]> {
    const response = await axiosInstance.get<ApiResponse<LocationDTO[]>>(
      `/categories/list`,
      {
        params: {
          productType,
        },
      },
    );
    return response.data.result;
  }
  static async getCityCategories(): Promise<CitiesResponse | undefined> {
    try {
      const response =
        await axiosInstance.get<ApiResponse<CitiesResponse>>(`/populars`);
      return response.data.result;
    } catch (error) {}
  }

  static async updateOrderNo(
    data: {
      id: string | number;
    }[],
  ) {
    try {
      const response = await axiosInstance.put(
        "/admin/categories/update-order",
        data,
      );
      return response.data.result;
    } catch (error: any) {
      throw error;
    }
  }
}

export default CategoryService;
